import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import AuthCallback from "./components/AuthCallback";
import ProtectedRoute from "./components/ProtectedRoute";
import DashboardLayout from "./layouts/DashboardLayout";
import Landing from "./pages/Landing";
import AuthPage from "./pages/AuthPage";
import PublicShop from "./pages/PublicShop";
import Overview from "./pages/dashboard/Overview";
import Products from "./pages/dashboard/Products";
import ProductDetail from "./pages/dashboard/ProductDetail";
import ShopSettings from "./pages/dashboard/ShopSettings";
import Account from "./pages/dashboard/Account";
import AdminMembers from "./pages/dashboard/AdminMembers";
import AdminShops from "./pages/dashboard/AdminShops";
import AppSettings from "./pages/dashboard/AppSettings";
import { SettingsProvider } from "./context/SettingsContext";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<AuthPage mode="login" />} />
      <Route path="/register" element={<AuthPage mode="register" />} />
      <Route path="/dashboard" element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
        <Route index element={<Overview />} />
        <Route path="products" element={<Products />} />
        <Route path="products/:id" element={<ProductDetail />} />
        <Route path="shop" element={<ShopSettings />} />
        <Route path="account" element={<Account />} />
        <Route path="members" element={<AdminMembers />} />
        <Route path="shops" element={<AdminShops />} />
        <Route path="settings" element={<AppSettings />} />
      </Route>
      <Route path="/:slug" element={<PublicShop />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <SettingsProvider>
      <AuthProvider>
        <AppRouter />
        <Toaster position="top-center" richColors />
      </AuthProvider>
      </SettingsProvider>
    </BrowserRouter>
  );
}

export default App;
